import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const CUTOFF_TIMES_QUERY = gql`
  query cutoffTimesWithClubZone($facilityId: ID) {
    cutoffTimes(facilityId: $facilityId) {
      baseHour
      baseTime
      baseTimezone
      baseTimezoneId
      dropoffDate
      pickupDate
    }
  }
`
export interface CutoffTimes {
  baseHour: number
  baseTime: string
  baseTimezone: string
  baseTimezoneId: string
  dropoffDate: string
  pickupDate: string
}

export interface CutoffTimesResponse {
  cutoffTimes: CutoffTimes
}

/**
 * Custom hook to fetch cutoff times for a specific club.
 * @param clubId - The ID of the club for which to fetch cutoff times.
 * @returns A query object containing the cutoff times data and status.
 */
export function useCutoffTimesApi(clubId?: string): UseQueryResult<CutoffTimes, Error> {
  const client = useGraphQLClient()

  const fetchCutoffTimes = async (): Promise<CutoffTimes> => {
    const data = await client.request<CutoffTimesResponse>(CUTOFF_TIMES_QUERY, {
      facilityId: clubId,
    })

    return data.cutoffTimes
  }

  return useQuery<CutoffTimes, Error>({
    queryKey: ['cutoffTimes', clubId],
    queryFn: fetchCutoffTimes,
    refetchOnWindowFocus: false,
    refetchInterval: 5 * 60 * 1000, // 5 minutes
  })
}
